import PricingSubmissionItem from '@app/model/pricing-automation/PricingSubmissionItem';
import PricingSubmissionState from '@app/model/pricing-automation/PricingSubmissionState';
import PricingSubmissionType from '@app/model/pricing-automation/PricingSubmissionType';
import _isEmpty from 'lodash/isEmpty';
import _min from 'lodash/min';
import _max from 'lodash/max';
import _uniq from 'lodash/uniq';

export class PricingSubmission {
	id: number
	creationDate: string
	submissionDate: string
	finishDate: string
	type: PricingSubmissionType
	state: PricingSubmissionState
	profileName?: string | null
	items: PricingSubmissionItem[]

	constructor(data: PricingSubmission) {
		Object.assign(this, data);
	}

	getDistinctRoomsCount() {
		if(_isEmpty(this.items)) return 0;
		return new Set(this.items.map(item => item.pricingArchitectureRoomId)).size;
	}

	getDistinctRoomIds() {
		if (_isEmpty(this.items)) return [];
		return _uniq(this.items.map(item => item.pricingArchitectureRoomId));
	}

	getFirstStatDate() {
		if (_isEmpty(this.items)) return null;
		return this.items.map(item => item.statDate).sort()[0];
	}

	getLastStatDate() {
		if (_isEmpty(this.items)) return null;
		return this.items.map(item => item.statDate).sort().reverse()[0];
	}

	getNumberOfDays() {
		if (_isEmpty(this.items)) return 0;
		return new Set(this.items.map(item => item.statDate)).size;
	}

	getLowestSubmittedPrice() {
		if (_isEmpty(this.items)) return null;
		return _min(this.items.map(item => item.applyPrice));
	}

	getHighestSubmittedPrice() {
		if (_isEmpty(this.items)) return null;
		return _max(this.items.map(item => item.applyPrice));
	}

	hasSucceeded() {
		return this.state === PricingSubmissionState.SUCCESS;
	}

	hasFailed() {
		return this.state === PricingSubmissionState.FAILED;
	}

	getSubmitterName() {
		const profileName = this.profileName?.trim() ?? '';
		if (profileName !== '') return profileName;
		return this.type === PricingSubmissionType.AUTOMATIC ? 'RoomPulse (automatic)' : 'Unknown user';
	}
}

export default PricingSubmission;
